import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f5868b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = {
  key: 1,
  class: "list"
}

import DleteButton from '@/components/DeleteButtonComponent.vue';
import { inject } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ListComponent',
  setup(__props) {

const tweets = inject('tweets');

const _deleteTweet = inject('deleteTweet');
const deleteTweet = (id: number) =>{
  _deleteTweet(id);
}

return (_ctx: any,_cache: any) => {
  return (_unref(tweets).length <= 0)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "No tweets have been added"))
    : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tweets), (tweet, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tweet.id
          }, [
            _createElementVNode("p", null, _toDisplayString(index) + "：" + _toDisplayString(tweet.description), 1),
            _createVNode(DleteButton, {
              onClick: ($event: any) => (deleteTweet(index))
            }, null, 8, ["onClick"])
          ]))
        }), 128))
      ]))
}
}

})